export const isExperienceEditor =
	document.body.classList.contains("pagemode-edit");
